import { useLayoutEffect, useState } from 'react';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

import { DEVICE } from '../config';

const useKeyboardOpenAndroid = () => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

    useLayoutEffect(() => {
        const onShow = () => setIsKeyboardOpen(true);
        const onHide = () => setIsKeyboardOpen(false);

        window.addEventListener('capacitor:keyboard:show', onShow);
        window.addEventListener('capacitor:keyboard:hide', onHide);

        return () => {
            window.removeEventListener('capacitor:keyboard:show', onShow);
            window.removeEventListener('capacitor:keyboard:hide', onHide);
        };
    }, []);

    return isKeyboardOpen;
};

// On Android/Capacitor, the Visual Viewport API used by use-detect-keyboard-open
// doesn't work correctly, so we use Capacitor keyboard events instead.
export const useKeyboardOpen = DEVICE === 'ANDROID' ? useKeyboardOpenAndroid : useDetectKeyboardOpen;

